<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Seller Customer Coverage'"
          :fields="fields"
          :items="data"
          :redirectDetail="false"
          :enableAddButton="true"
          :removeButton="true"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="user_group">Customer Group</label>
              <model-select
                class="form-control"
                id="user_group"
                :options="customerCoverageList"
                v-model="$v.customerCoverageForm.user_group.$model"
                :isError="$v.customerCoverageForm.user_group.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.customerCoverageForm.user_group.$invalid"
                class="invalid-feedback-custom"
              >Customer group should be filled.</div>
            </div>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.customerCoverageForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "AgentCoverage",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "SellerCoverage",
      items: [],
      addButton: false,
      customerCoverageForm: tableInterfaces.agent_coverage_user,
      isLoading: false,
      activeTab: 0,
      districtList: [],
    //   checkedFlag: "Agent",
      fields: [
        { key: "agent_code", label: "Seller Code", sorter: true },
        { key: "customer_coverage", label: "User Group", sorter: true },
         { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agent: {
      type: [Array, Object],
      default: () => [],
    },
    customerCoverageList: {
      type: [Array, Object],
      default: () => [],
    },
    agentCustomerCoverage: {
          type: [Array, Object],
      default: () => [],
    },
    agentStatus: {
        type: String,
        default: '',
    },
  },
  validations: {
    customerCoverageForm: {
      agent_code: { },
      user_group: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function() {
      return (this.items.length > 0) ? this.items: this.agentCustomerCoverage;
    }
  },
  methods: {
    init: function () {
    },
    refreshAgentCoverageUser: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/agent/agent_coverage_user/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
          
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    removeData: function(item) {
       if (confirm("Do you want to remove this data ?")) {
      this.isLoading = true;
          this.axios
            .delete("console/agent/agent_coverage_user/"+item.id)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshAgentCoverageUser(this.agent.id);
            });
       }
      // bikin api untuk remove 
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent_coverage_user) {
        tableInterfaces.agent_coverage_user[i] = null;
      }
      this.customerCoverageForm = tableInterfaces.agent_coverage_user;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.customerCoverageForm.agent_code = this.agent.agent_code;
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/agent/agent_coverage_user/add", this.customerCoverageForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshAgentCoverageUser(this.agent.id);
            });
        }
      
    },
    filterDistrict: function(){
      this.axios.get("/console/dropdown/district/" + this.customerCoverageForm.province)
      .then((response) => {
        this.districtList = response.data.data;
      });
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
